import Container from '@mui/material/Container';
import { GridApiPro, useGridApiRef } from '@mui/x-data-grid-pro';
import Box from '@mui/material/Box';
import { MutableRefObject, useState } from 'react';
import Fab from '@mui/material/Fab';
import { useTheme } from '@mui/material';
import { TCustomTheme } from '@mgm/common/theme';
import { useCustomTheme } from '@mgm/common/hooks/useCustomTheme';
import { Iconify } from '@mgm/common/components';
import { TimesheetsHeader, TimesheetsTable, TimesheetsTour } from '../../features/timesheets';
import { PAGES_ANALYTICS_TITLES } from '../../utils/enums';
import { PageHelmet } from '../../components';
import { useShopStatusQueryAPI } from '../../hooks/api/useClock';
import { useSheetsPermissions } from '../../features/timesheets/hooks';

const TimesheetsPage = () => {
  const [runTour, setRunTour] = useState(false);
  const { permissions } = useSheetsPermissions();
  const theme = useTheme() as TCustomTheme;
  const { isMobile } = useCustomTheme(theme);

  const apiRef = useGridApiRef() as MutableRefObject<GridApiPro>;
  useShopStatusQueryAPI();

  const handleStartTour = () => {
    setRunTour(true);
  };

  return (
    <PageHelmet title={PAGES_ANALYTICS_TITLES.TIMESHEETS}>
      <Container
        sx={{
          px: { xs: 0, lg: 2 },
        }}
        maxWidth={false}
      >
        <TimesheetsTour runTour={runTour} setRunTour={setRunTour} />
        <TimesheetsHeader />
        <TimesheetsTable apiRef={apiRef} />
        {permissions.isAllowManage && (
        <Box onClick={handleStartTour}>
          <Fab
            variant="circular"
            disableFocusRipple
            size="small"
            sx={{
              position: 'fixed',
              top: isMobile ? 60 : 90,
              right: 32,
              backgroundColor: 'white',
              zIndex: 1500,
            }}
          >
            <Iconify icon="cuida:help-outline" width={32} sx={{ color: '#A855F7' }} />
          </Fab>
        </Box>
        )}
      </Container>
    </PageHelmet>
  );
};

export default TimesheetsPage;
